
require('./transfersAgendaView.scss');
const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const accountsActions = require('actions/getAccounts');
const beneficiariesActions = require('actions/beneficiaries');

// @components
const TransfersAgenda = require('components/transfers/transfersAgenda/transfersAgenda');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');

class TransfersAgendaView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        this.props.requestAccounts();
        this.props.requestBeneficiaries();
    }

    render() {
        const {
            immAccounts,
            immBeneficiaries,
            immScreen,
        } = this.props;

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('breadcrumb-agenda')
            }
        ];
        const tutorial = (
            <TutorialLauncher type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-agendaBeneficiariosTitle')}
            />
        );
        let moreOptionsButton;
        let optionsButton;

        if (immAccounts && immAccounts.get('byOrder').get(0)) {
            const immAccount = immAccounts.get('byId').get(immAccounts.get('byOrder').get(0));
            moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton immAccount={immAccount} />);
        }

        const transfersAgendaClassName = contactCenterClassName('transfers-agenda-view')
        const transfersAgendaBodyClassName = contactCenterClassName('transfers-agenda-view__body', 'grid-view__body')
        return (
            <div className={transfersAgendaClassName}>
                <div className="container-fluid">
                    <div className="row transfers-agenda-view--header-identifier">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('transfersAgenda-headerTitle')} >
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className={transfersAgendaBodyClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <TransfersAgenda
                                    immBeneficiaries={immBeneficiaries}
                                    immScreen={immScreen}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TransfersAgendaView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    requestBeneficiaries: PropTypes.func.isRequired
};

module.exports.constructor = TransfersAgendaView;
module.exports.TransfersAgendaView = connect(
    state => ({
        immAccounts: state.accounts,
        immBeneficiaries: state.beneficiaries,
        immScreen: state.screen,
    }), {
        requestAccounts: accountsActions.requestAccounts,
        requestBeneficiaries: beneficiariesActions.requestBeneficiaries
    })(TransfersAgendaView);
